// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-work {
  --my-work-padding: var(--my-work-padding-mobile);
  --my-work-ncol: var(--my-work-ncol-mobile);

  padding: var(--my-work-padding);
  display: flex;
  flex-direction: column;
  gap: var(--my-work-title-gap);
}

.my-work__title {
  font-family: var(--h2-font);
  font-size: var(--h2-fontsize);
  text-align: center;
  font-weight: bold;
}

.my-work__list {
  width: 100%;
  display: grid;
  gap: var(--my-work-list-gap);

  grid-template-columns: repeat(var(--my-work-ncol), minmax(0, 1fr));
  grid-auto-rows: minmax(0, 1fr);
}

/* mobile, horizontal */
@media only screen and (max-height: 550px) and (orientation: landscape) {
  .my-work {
    --my-work-padding: var(--my-work-padding-mobile-landscape);
    --my-work-ncol: var(--my-work-ncol-mobile-landscape);
  }
}

/* tablet or larger */

@media only screen and (min-width: 767px) and (min-height: 551px) {
  .my-work {
    --my-work-padding: var(--my-work-padding-tablet);
    --my-work-ncol: var(--my-work-ncol-tablet);
  }

  .my-work__title {
    text-align: left;
  }
}

/* desktop or larger */
@media only screen and (min-width: 961px) and (orientation: landscape) and (min-height: 551px) {
  .my-work {
    --my-work-padding: var(--my-work-padding-desktop);
    --my-work-ncol: var(--my-work-ncol-desktop);
  }
}
`, "",{"version":3,"sources":["webpack://./src/css-modules/myWork.css"],"names":[],"mappings":"AAAA;EACE,gDAAgD;EAChD,0CAA0C;;EAE1C,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,4BAA4B;;EAE5B,kEAAkE;EAClE,8BAA8B;AAChC;;AAEA,uBAAuB;AACvB;EACE;IACE,0DAA0D;IAC1D,oDAAoD;EACtD;AACF;;AAEA,qBAAqB;;AAErB;EACE;IACE,gDAAgD;IAChD,0CAA0C;EAC5C;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,iDAAiD;IACjD,2CAA2C;EAC7C;AACF","sourcesContent":[".my-work {\r\n  --my-work-padding: var(--my-work-padding-mobile);\r\n  --my-work-ncol: var(--my-work-ncol-mobile);\r\n\r\n  padding: var(--my-work-padding);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--my-work-title-gap);\r\n}\r\n\r\n.my-work__title {\r\n  font-family: var(--h2-font);\r\n  font-size: var(--h2-fontsize);\r\n  text-align: center;\r\n  font-weight: bold;\r\n}\r\n\r\n.my-work__list {\r\n  width: 100%;\r\n  display: grid;\r\n  gap: var(--my-work-list-gap);\r\n\r\n  grid-template-columns: repeat(var(--my-work-ncol), minmax(0, 1fr));\r\n  grid-auto-rows: minmax(0, 1fr);\r\n}\r\n\r\n/* mobile, horizontal */\r\n@media only screen and (max-height: 550px) and (orientation: landscape) {\r\n  .my-work {\r\n    --my-work-padding: var(--my-work-padding-mobile-landscape);\r\n    --my-work-ncol: var(--my-work-ncol-mobile-landscape);\r\n  }\r\n}\r\n\r\n/* tablet or larger */\r\n\r\n@media only screen and (min-width: 767px) and (min-height: 551px) {\r\n  .my-work {\r\n    --my-work-padding: var(--my-work-padding-tablet);\r\n    --my-work-ncol: var(--my-work-ncol-tablet);\r\n  }\r\n\r\n  .my-work__title {\r\n    text-align: left;\r\n  }\r\n}\r\n\r\n/* desktop or larger */\r\n@media only screen and (min-width: 961px) and (orientation: landscape) and (min-height: 551px) {\r\n  .my-work {\r\n    --my-work-padding: var(--my-work-padding-desktop);\r\n    --my-work-ncol: var(--my-work-ncol-desktop);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
